import api, { AUTH_BASE_URL } from "./api";

/**
 * POST /api/login
 * Body: { email, password }  (matches the Laravel validator you shared)
 *
 * The backend response shape can vary, so this defensively looks for
 * a token under a few common keys, and for the user object under a
 * few common keys too. Adjust the `token` / `user` extraction below
 * if your API responds differently.
 */
export async function loginRequest(email, password) {
  const res = await api.post(`${AUTH_BASE_URL}/login`, { email, password });
  const data = res.data || {};

  const token =
    data.token ||
    data.access_token ||
    data.data?.token ||
    data.data?.access_token;

  const user = data.user || data.data?.user || { email };

  if (!token) {
    throw new Error("Login succeeded but no token was returned by the API.");
  }

  return { token, user };
}
